import type { AnnouncementBannerDisplayState } from './AnnouncementBannerDisplayState.types.tsx';

export const JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY =
	'jsm-grace-period-announcement-dismiss-state' as const;

export const DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE: AnnouncementBannerDisplayState = {};

export const FALLBACK_GP_END_DATE: Date = new Date('10/16/2025');
